import React from "react";
import { Flex, Text } from "rebass";

import { RecordIcon } from "../RecordIcon";

interface IProps {
  title: string;
  bookType: string;
  time?: string;
  coverImagePath?: string;
  page?: number;
  progress?: number;
}

export const RecordMetaData: React.FC<IProps> = ({ bookType, title, coverImagePath, time, progress = 0 }) => (
  <Flex
    justifyContent="space-between"
    alignItems="center"
    mt="23px"
    mb="10px"
  >
    <Text as="p" fontSize="14px">
      <Text
        as="strong"
        color="#9b9eb5"
        css="text-transform: uppercase;"
      >
        {bookType}
      </Text>

      {
        time && (
          <>
            &nbsp;

            <Text
              as="strong"
              color="sp-blue"
              css="text-transform: capitalize;"
            >
              {`${time} min listen`}
            </Text>
          </>
        )
      }
    </Text>

    <Flex alignItems="center">
      <Text
        mr="14px"
        fontSize="14px"
        color="sp-blue"
      >
        {`${progress} min`}
      </Text>

      <RecordIcon
        variant="sm"
        title={title}
        coverImagePath={coverImagePath}
      />
    </Flex>
  </Flex>
);
